---
meta:
  - title: Compartir playbook con usuarios - IUSPRO Docs
  - description: Aprende a compartir playbooks.
---

# Compartir playbook con usuarios

Los playbooks se pueden compartir con otros usuarios de su organización para que todos puedan usarlos.

## ¿Por qué compartir playbooks?

### Caso común

Una persona con experiencia crea un playbook para revisar un tipo de documento (por ejemplo, contratos laborales). Luego quiere que otras personas en la firma también puedan usar ese playbook para revisar documentos.

### Beneficios

- **Consistencia**: Todos revisan con los mismos criterios
- **Eficiencia**: No cada persona tiene que crear su propio playbook
- **Calidad**: El playbook lo crea quien tiene la experiencia

## Como compartir un playbook

1. **Abra el playbook** que desea compartir
2. **Busque la opción "Compartir"**
3. **Seleccione con quién compartir**:
   - Todos los usuarios de la organización
   - Usuarios específicos

## ¿Qué pueden hacer con un playbook compartido?

Los usuarios con acceso al playbook pueden:

- **Usarlo para revisar documentos**
- **Ver las reglas del playbook**

Lo que usualmente NO pueden hacer (depende de permisos):

- Modificar el playbook original
- Eliminar el playbook

## Flujo de trabajo típico

1. **Experto crea el playbook**: La persona con experiencia define las reglas
2. **Experto comparte el playbook**: Lo comparte con su equipo
3. **Equipo usa el playbook**: Todos pueden revisar documentos con esos criterios
4. **Experto actualiza cuando necesario**: Si hay cambios, actualiza el playbook y todos ven la versión actualizada

## Playbooks vs Ejecuciones

Es importante entender la diferencia:

- **Playbooks**: Se pueden compartir fácilmente
- **Ejecuciones** (documentos revisados): Son privadas por defecto, pero también se pueden compartir si es necesario

## Escenario de uso

**Firma de abogados con 10 abogados**:

1. El socio principal crea un playbook "Requisitos de contratos laborales"
2. Lo comparte con todos los abogados de la firma
3. Cada abogado puede revisar sus propios contratos usando ese playbook
4. Todos siguen los mismos estándares de calidad
5. Si el socio actualiza el playbook, todos usan la versión actualizada automáticamente

Esto asegura que todos los contratos que salen de la firma cumplen los mismos estándares.
